import { gql } from "@apollo/client";

import { JOB_FIELDS, OPT_OUT_FIELDS } from "src/graphql/fragments";

export const LIST_OPT_OUTS = gql`
  ${OPT_OUT_FIELDS}
  query listOptOuts(
    $filter: OptOutFilterInput
    $sort: OptOutSortInput
    $limit: Int
    $offset: Int
    $subaccountId: ID!
  ) {
    listOptOuts(
      filter: $filter
      sort: $sort
      limit: $limit
      offset: $offset
      subaccountId: $subaccountId
    ) {
      totalCount
      optOuts {
        ...OptOutFields
      }
    }
  }
`;

export const CREATE_OPT_OUT = gql`
  ${OPT_OUT_FIELDS}
  mutation createOptOut($phoneNumber: String!, $subaccountId: ID!) {
    optOutCreate(phoneNumber: $phoneNumber, subaccountId: $subaccountId) {
      ...OptOutFields
    }
  }
`;

export const UPLOAD_OPT_OUTS = gql`
  ${JOB_FIELDS}
  mutation uploadOptOuts(
    $uploadToken: String!
    $phoneNumberColumn: String!
    $subaccountId: ID!
  ) {
    optOutUpload(
      uploadToken: $uploadToken
      columnMappings: { phoneNumberColumn: $phoneNumberColumn }
      subaccountId: $subaccountId
    ) {
      ...JobFields
    }
  }
`;

export const GET_OPT_OUT_JOBS = gql`
  ${JOB_FIELDS}
  query getOptOutJobs(
    $jobType: JobType
    $statuses: [JobStatus!]
    $sort: JobSortInput
    $limit: Int
    $offset: Int
    $subaccountId: ID!
  ) {
    listJobs(
      filter: { type: $jobType, statuses: $statuses }
      sort: $sort
      limit: $limit
      offset: $offset
      subaccountId: $subaccountId
    ) {
      totalCount
      jobs {
        ...JobFields
      }
    }
  }
`;

export const DELETE_OPT_OUT = gql`
  ${OPT_OUT_FIELDS}
  mutation deleteOptOut($id: ID!) {
    optOutDelete(id: $id) {
      ...OptOutFields
    }
  }
`;

export const BULK_DELETE_OPT_OUTS = gql`
  ${JOB_FIELDS}
  mutation bulkDeleteOptOuts($subaccountId: ID!) {
    optOutBulkDelete(subaccountId: $subaccountId) {
      ...JobFields
    }
  }
`;
